<template>
  <div id="bedrooms-list">
    <SidebarLayout2 :breadcrumb="breadcrumb" pageTitle="Agrupador de quartos">
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading>
            Ações da página
          </Heading>

          <Button
            :hasIcon="true"
            @click="$router.push({ path: '/agrupador-quartos/novo' })"
            class="page-actions--button"
          >
            Criar agrupador
          </Button>
          <Button
            :disabled="disableEditButton"
            class="page-actions--button"
            @click.stop.prevent="
              $router.push({
                path: `/agrupador-quartos/editar/${selectedRows[0].codigo}`
              })
            "
          >
            Editar
          </Button>
          <Button
            :disabled="disabledDeleteButton"
            variation="error"
            class="page-actions--button"
            @click.stop.prevent="deleteModal(selectedRows.codigo)"
          >
            Excluir
          </Button>
        </SidebarBlock>

        <!-- DICAS -->
        <SidebarBlock>
          <Heading>
            Dica
          </Heading>
          <Paragraph class="page-actions--tip-text">
            Crie grupos para facilitar a análise dos dashboards, fazendo um
            compilamento das informações para análises de forma geral. <br />
            <br />
            Exemplo: Ao analisar um determinado grupo de quartos, é possível ver
            no detalhe o comportamento de compra e resultados.
          </Paragraph>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO -->
      <template #content>
        <span class="filters">
          <!-- BUSCA -->
          <SearchInput v-model="filterByName" class="filters--search-input" />
        </span>

        <!-- TABELA -->
        <DataTable
          :cols="cols"
          :sortable="true"
          :isLoading="loading"
          :rows="rows"
          :selectableRow="true"
          :colsMinWidths="minWidths"
          ref="dataTable"
          maxHeight="1080"
          class="datatable"
          @getSelectedRows="selectedRows = $event"
        >
          <template v-slot:nome="data">
            {{ data.rowDataObj.nome }}
            <button
              class="datatable--info-button"
              @click.stop.prevent="buttonInfo(data.rowDataObj.codigo)"
            >
              <Icon icon="info" class="datatable--info-icon" />
            </button>
          </template>
          <template v-slot:editar="data">
            <div>
              <button
                class="datatable--link__edit"
                @click.stop.prevent="
                  $router.push({
                    path: `/agrupador-quartos/editar/${data.rowDataObj.codigo}`
                  })
                "
              >
                Editar
              </button>
            </div>
          </template>
        </DataTable>
        <!-- PAGINAÇÃO -->
        <PmwPagination
          :items="filterTable"
          :itemsPerPage="pagination.itemsPerPage"
          :currentPage="pagination.currentPage"
          :totalItems="filterTable.length"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          class="pagination"
          @changePagination="changePagination"
        />
        <!-- MODAL DELEÇÃO -->
        <AlertModal
          v-model="showDeleteModal"
          :buttonClose="true"
          title="Excluir agrupador de quartos"
          @alert-modal-cancel="cancelDisable()"
          @alert-modal-confirm="disableRoom()"
        >
          <template #text>
            Ao excluir esse agrupador, não será mais possível visualizar as
            informações contidas nele de forma compilada em relatórios. <br />
            Tem certeza de que quer fazer isso?
          </template>
        </AlertModal>
        <Modal
          v-model="modalTable"
          :hasFooter="false"
          :width="'auto'"
          :smallerHeader="true"
          :smallHeader="true"
          :title="title"
          id="modal"
          class="modal"
          @modal-cancel="clearSelected()"
        >
          <template slot="body-content">
            <div class="modalInfo">
              <div class="row">
                <div v-if="linhas.length > 0" class="col modal-spaces">
                  <CleanTable :columns="colunas" :rows="linhas" />
                </div>
                <div v-else>
                  Não existem quartos cadastradas neste agrupador
                </div>
              </div>
            </div>
          </template>
        </Modal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
/** Componentes da lib */
import AlertModal from '@solucoes/components-lib-tmp/src/components/patterns/AlertModal'
import Button from '@solucoes/components-lib-tmp/src/components/elements/Button'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import Heading from '@solucoes/components-lib-tmp/src/components/elements/Heading'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'
import Modal from '@solucoes/components-lib-tmp/src/components/patterns/Modal'
import CleanTable from '@solucoes/components-lib-tmp/src/components/patterns/CleanTable'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'

/** Imports do projeto */
import SidebarLayout2 from '@/layouts/SidebarLayout2'

export default {
  name: 'roomBundlerList',
  components: {
    AlertModal,
    Button,
    DataTable,
    Heading,
    PmwPagination,
    SearchInput,
    Icon,
    Paragraph,
    Modal,
    CleanTable,
    SidebarLayout2,
    SidebarBlock
  },
  data() {
    return {
      /** Temporário - Teste de valores da tabela de informações */
      colunas: [
        {
          label: 'Hotéis ',
          value: 'hotel',
          name: 'hotel'
        },
        {
          label: 'Quartos',
          value: 'nome',
          name: 'nome'
        }
      ],
      linhas: [],
      /** ------------------- */
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Agrupador de quartos'
        }
      ],

      minWidths: {
        editar: '75px'
      },

      /** Colunas da tabela */
      cols: [
        {
          alias: 'Nome',
          name: 'nome'
        },
        {
          alias: 'Ações',
          name: 'editar'
        }
      ],
      /** V-model da busca */
      filterByName: '',
      /** Dados da paginação */
      pagination: {
        totalItems: 0,
        currentPage: 1,
        itemsPerPage: 25,
        startItemIndex: 1,
        lastItemIndex: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '75',
            value: 75
          },
          {
            text: '100',
            value: 100
          }
        ]
      },
      /** Linhas da tabela (dados) */
      rows: [],
      /** Armazena dados de retorno */
      allRooms: [],
      /** Loading da tabela */
      loading: true,
      /** Array das linhas selecionadas */
      selectedRows: [],
      /** Usuário a ser deletado */
      bedroomDelete: null,
      /** Exibição da modal de deleção */
      showDeleteModal: false,
      /** titulo de modal de informação */
      title: null,
      modalTable: false,
      selectedBundler: null
    }
  },
  computed: {
    /** Desabilita botão de deletar */
    disabledDeleteButton() {
      if (this.selectedRows.length >= 1) {
        return false
      }
      return true
    },

    /** Desabilita botão de editar */
    disableEditButton() {
      if (this.selectedRows.length === 1) {
        return false
      }
      return true
    },

    /** Filtro de pesquisa da tabela */
    filterTable() {
      const results = this.allRooms.filter((data) => {
        return (
          data.nome.toLowerCase().indexOf(this.filterByName.toLowerCase()) > -1
        )
      })
      return results
    }
  },
  created() {
    /** Faz a chamada da api */
    this.getAllRooms()
  },
  methods: {
    /** Ação do botão de informação */
    buttonInfo(codigo) {
      this.modalTable = true
      this.getSingleRoom(codigo)
      this.selectedBundler = codigo
    },

    /** Retorna dados da listagem */
    getAllRooms() {
      this.loading = true
      this.$room.getRoomBundlers().then((response) => {
        const results = response.data
        results.map(function(key, index) {
          results[index]['data'] = {
            nome: key.nome,
            codigo: key.codigo,
            quartos: key.quartos
          }
        })
        this.allRooms = results
      })
      this.loading = false
    },

    /** Retorna dados do usuário */
    getSingleRoom(codigo) {
      this.$room.getRoomBundlers(codigo).then((response) => {
        const single = response.data.quartos
        this.title = response.data.nome
        if (single.length > 0) {
          single.map(function(item) {
            return item
          })
          this.linhas = single
        } else {
          this.linhas = []
        }
      })
    },

    /** Desabilitar usuário */
    disableRoom() {
      const DeleteroomBundler = this.ifExists(
        this.selectedRows.length > 0
          ? this.selectedRows.map((item) => {
              return parseInt(item.codigo)
            })
          : [this.bedroomDelete]
      )
      this.$room
        .disableRoom({ agrupadores: DeleteroomBundler })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Agrupador de quartos excluido com sucesso'
          })
          this.getAllRooms()
          this.resetPagination()
          this.selectedRows = []
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desativar agrupador de quartos'
          })
        })
    },

    /** Controle de deleção */
    deleteModal(bedroomId) {
      this.showDeleteModal = true
      this.bedroomDelete = bedroomId
    },

    /** Cancela deleção */
    cancelDisable() {
      this.showDeleteModal = false
      this.bedroomDelete = null
    },

    /** Verificar se dado existe */
    ifExists(element) {
      /** se for array */
      let result = null
      if (element && typeof element.value !== 'undefined') {
        result = element.value
        /** se for string */
      } else if (element !== '') {
        result = element
      }
      return result === true ? 1 : result
    },

    /** Usado para controle da paginação */
    changePagination(childData) {
      this.pagination.currentPage = childData.currentPage
      this.rows = childData.items
    },

    /** Reseta dados da paginação */
    resetPagination() {
      this.pagination.currentPage = 1
      this.pagination.startItemIndex = 1
      this.pagination.itemsPerPage = 25
      this.pagination.lastItemIndex = this.pagination.itemsPerPage
    },

    /** Limpa agrupador selecionado */
    clearSelected() {
      this.selectedBundler = null
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  ::v-deep {
    p {
      margin: 0;
    }
    .select--button {
      font-weight: 500;
    }
  }
}
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}
::v-deep .content {
  /** Padding abaixo do título da página */
  .page-heading {
    padding-bottom: 24px;
  }
}
::v-deep .datable-grid-wrapper {
  .col {
    padding-left: 14px;
  }
}
.sidebar {
  &-title {
    color: #474747;
    margin-top: 35px;
    margin-bottom: 15px;
    margin-left: 15px;
    max-width: 215px;
  }
  &-tip-title {
    color: #474747;
    margin-top: 35px;
    max-width: 215px;
  }
  &-tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    width: 215px;
    gap: 10px;
    margin: auto;
  }
}
.filters {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;

  &--search-input {
    width: 215px;
  }

  &--more {
    width: 225px;
  }
}
.links {
  border: none;
  background-color: inherit;
  &.edit {
    color: #466af0;
  }
  &.delete {
    color: #e0414b;
  }
}
.datatable {
  &--info-button {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
  }
  &--info-icon {
    margin-left: 5px;
    height: 15px;
    width: 15px;
    color: #7f7f7f;
    transition: color $pmw-color-anim linear;

    &:hover {
      color: $pmw-blue;
    }
  }
  &--link {
    &__edit {
      border: none;
      background-color: inherit;
      color: #466af0;
    }
    &__delete {
      border: none;
      background-color: inherit;
      color: #e0414b;
    }
  }
  ::v-deep {
    .pmw-col.pmw-th:nth-child(3) {
      pointer-events: none;
      max-width: 20px;
      .pmw-sort-icons {
        display: none;
      }
      .pmw-label {
        margin-left: 5px;
      }
    }
    .pmw-col.pmw-td:nth-child(3) {
      max-width: 25px;
      .pmw-sort-icons {
        display: none;
      }
    }
  }
}

button:focus {
  outline: none;
  outline: 0px;
}
.modalInfo {
  padding: 25px;
}
#modal {
  :v-deep {
    section.modal-component--header {
      padding: 0px;
    }
  }
}
.page-actions {
  padding-top: 50px;
  &--button {
    width: 100%;
    cursor: pointer;

    & + .page-actions--button {
      margin-top: 10px;
    }
  }
  &--tip-text {
    color: #474747;
    font-size: 14px;
    line-height: 21px;
    max-width: 215px;
  }
}
</style>
